var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkFlowFlowUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 51,
    viewBox: "0 0 40 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.011 25.7459H27.5566C25.9256 25.7459 24.602 27.0679 24.602 28.6968V30.4673H21.0566V23.6426L19.8749 23.6427V30.4674H16.3294V28.6969C16.3294 27.068 15.0058 25.746 13.3749 25.746H3.9204C2.28948 25.746 0.96582 27.068 0.96582 28.6969V33.4181C0.96582 35.047 2.28948 36.369 3.9204 36.369H8.05678V42.8608C8.05678 44.4896 9.38044 45.8116 11.0114 45.8116H24.6022V47.5821C24.6022 49.211 25.9259 50.533 27.5568 50.533H37.0112C38.6422 50.533 39.9658 49.211 39.9658 47.5821V42.8609C39.9658 41.232 38.6422 39.91 37.0112 39.91H32.8747V36.3691H37.0111C38.642 36.3691 39.9657 35.0471 39.9657 33.4183V28.697C39.9656 27.0709 38.6419 25.7459 37.011 25.7459ZM2.14763 33.418V28.6968C2.14763 27.7201 2.94237 26.9262 3.9204 26.9262H13.3749C14.3528 26.9262 15.1476 27.72 15.1476 28.6968V33.418C15.1476 34.3947 14.3529 35.1886 13.3749 35.1886H3.9204C2.94237 35.1886 2.14763 34.3947 2.14763 33.418ZM38.7838 42.8605V47.5818C38.7838 48.5585 37.989 49.3523 37.011 49.3523H27.5566C26.5786 49.3523 25.7838 48.5586 25.7838 47.5818V42.8605C25.7838 41.8839 26.5785 41.09 27.5566 41.09H37.011C37.989 41.0901 38.7838 41.8839 38.7838 42.8605ZM31.6929 39.9098H27.5566C25.9256 39.9098 24.602 41.2318 24.602 42.8607V44.6312H11.0112C10.0333 44.6312 9.23847 43.8375 9.23847 42.8607V36.3689H13.3749C15.0058 36.3689 16.3294 35.0469 16.3294 33.418V31.6475H24.6021V33.418C24.6021 35.0469 25.9258 36.3689 27.5567 36.3689H31.6931V39.9098H31.6929ZM38.7838 33.418C38.7838 34.3947 37.989 35.1886 37.011 35.1886H27.5566C26.5786 35.1886 25.7838 34.3948 25.7838 33.418V28.6968C25.7838 27.7201 26.5785 26.9262 27.5566 26.9262H37.011C37.9889 26.9262 38.7838 27.72 38.7838 28.6968V33.418Z",
    fill: "url(#paint0_linear_985_5135)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6022 31.0574C11.6022 30.7298 11.3392 30.4673 11.0112 30.4673H6.28408C5.9561 30.4673 5.69312 30.7299 5.69312 31.0574C5.69312 31.3849 5.9561 31.6476 6.28408 31.6476H11.0113C11.3393 31.6476 11.6022 31.3849 11.6022 31.0574Z",
    fill: "url(#paint1_linear_985_5135)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6473 30.4673H29.9201C29.5921 30.4673 29.3291 30.7299 29.3291 31.0574C29.3291 31.3849 29.5921 31.6476 29.9201 31.6476H34.6473C34.9753 31.6476 35.2383 31.3849 35.2383 31.0574C35.2383 30.7298 34.9753 30.4673 34.6473 30.4673Z",
    fill: "url(#paint2_linear_985_5135)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3293 45.2211C29.3293 45.5486 29.5923 45.8113 29.9203 45.8113H34.6475C34.9755 45.8113 35.2385 45.5486 35.2385 45.2211C35.2385 44.8935 34.9755 44.6309 34.6475 44.6309H29.9203C29.5922 44.631 29.3293 44.8966 29.3293 45.2211Z",
    fill: "url(#paint3_linear_985_5135)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3746 11.5815H34.6474C34.3194 11.5815 34.0564 11.8442 34.0564 12.1718C34.0564 12.4993 34.3194 12.762 34.6474 12.762H39.3746C39.7026 12.762 39.9655 12.4993 39.9655 12.1718C39.9655 11.8442 39.7026 11.5815 39.3746 11.5815Z",
    fill: "url(#paint4_linear_985_5135)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3746 16.3032H34.6474C34.3194 16.3032 34.0564 16.5659 34.0564 16.8934C34.0564 17.221 34.3194 17.4837 34.6474 17.4837H39.3746C39.7026 17.4837 39.9655 17.221 39.9655 16.8934C39.9655 16.5688 39.7026 16.3032 39.3746 16.3032Z",
    fill: "url(#paint5_linear_985_5135)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5085,
    cy: 5.49489,
    rx: 4.96845,
    ry: 4.96218,
    fill: "url(#paint6_linear_985_5135)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.6599,
    y: 10.9297,
    width: 17.6972,
    height: 13.8941,
    rx: 3,
    fill: "url(#paint7_linear_985_5135)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_985_5135",
    x1: 20.4658,
    y1: 23.6426,
    x2: 20.4658,
    y2: 50.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_985_5135",
    x1: 8.64763,
    y1: 30.4673,
    x2: 8.64763,
    y2: 31.6476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_985_5135",
    x1: 32.2837,
    y1: 30.4673,
    x2: 32.2837,
    y2: 31.6476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_985_5135",
    x1: 32.2839,
    y1: 44.6309,
    x2: 32.2839,
    y2: 45.8113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_985_5135",
    x1: 37.011,
    y1: 11.5815,
    x2: 37.011,
    y2: 12.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_985_5135",
    x1: 37.011,
    y1: 16.3032,
    x2: 37.011,
    y2: 17.4837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_985_5135",
    x1: 20.5085,
    y1: 0.532715,
    x2: 20.5085,
    y2: 10.4571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_985_5135",
    x1: 20.5085,
    y1: 10.9297,
    x2: 20.5085,
    y2: 24.8238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkFlowFlowUser);
export default __webpack_public_path__ + "static/media/WorkFlowFlow_user.48022dd38f41b777a76caf4ff46539e5.svg";
export { ForwardRef as ReactComponent };